import type { StyleProps, SystemStyleObject } from "@ecco/ui/types";

export const styles = {
    link: {
        position: "relative",
        display: "block",
        whiteSpace: "break-spaces",
        textDecoration: "none",
        _hover: { textDecoration: "none" },
        minWidth: "250px",
        _focus: { outline: "none" },
        _after: {
            inset: 0,
            zIndex: 1,
            opacity: 0,
            content: '""',
            position: "absolute",
            pointerEvents: "none",
            transitionProperty: "opacity",
            transitionDuration: "0.15s",
        },
        _focusVisible: {
            outline: "none",
            _after: {
                opacity: 1,
                outline: "1px solid black",
                outlineOffset: "-1px",
            },
        },
    },
    grid: {
        gridTemplateRows: "1fr auto",
        alignItems: "end",
    },
    imageWrapper: {
        position: "relative",
        zIndex: 0,
        overflow: "hidden",
        width: "100%",
        aspectRatio: "3/2",
    },
    textLabelLeft: {
        mt: 2,
        fontSize: ["mobileLinkL1", "desktopBodyB3"],
        color: "black",
        fontWeight: "bold",
    },
    textLabelDefault: {
        mt: 2,
        fontSize: ["mobileLinkL1", "mobileLinkL1", "desktopH2", "desktopH2"],
        color: "black",
        fontWeight: "bold",
    },
    textDescription: {
        mt: 2,
        fontWeight: "bold",
    },
} satisfies Record<string, StyleProps | SystemStyleObject>;
